import * as React from 'react'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepSLRGraduationDate: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>When did you graduate or last attend school?</StepTitle>
    <ApplicationField
      onEnter={props.onEnter}
      onChange={props.handleChangeAndContinue.bind(null, Fields.GraduationDate)}
      product={Product.Loan}
      field={Fields.GraduationDate}
    />
  </Wrapper>
)

export default StepbystepApplicationStepSLRGraduationDate
